export default {
  BUY_SUCCESS_HEADER: "Your funds have been purchased!",
  BUY_SUCCESS_SUBHEADING:
    "Your account is now setup and your funds have been invested!",
  BUY_SUCCESS_BUTTON_HEADING: "Check Status",
};
